<template>
	<BaseCmsShare :networks="['facebook', 'whatsapp', 'viber', 'link']" v-slot="{items, onShare}">
		<div class="share" v-if="items.length">
			<p class="share-title"><BaseCmsLabel code="share_with_friends" /></p>
			<div class="share-items">
				<div v-for="network in items" :key="network" :class="['ss-item', 'ss-' + network.code]" :title="network.title" @click="onShare(network), showTooltip(network)">
					<span class="title" v-if="network.code == 'link'"><BaseCmsLabel code="copy_link" /></span>
					<span class="share-tooltip" v-if="network.code == 'link' && tooltip"><BaseCmsLabel code="share_link_copied" /></span>
				</div>
			</div>
		</div>
	</BaseCmsShare>
</template>

<script setup>
	const tooltip = ref(false);
	let timer;
	function showTooltip(network) {
		clearTimeout(timer);

		if (network.code == 'link') {
			tooltip.value = true;
			timer = setTimeout(() => {
				tooltip.value = false;
			}, 1000);
		}
	}

	onBeforeUnmount(() => {
		clearTimeout(timer);
	});
</script>

<style scoped lang="less">
	.share{
		padding: 30px 0 0;
		@media (max-width: @m){padding-top: 14px;}	
	}
	.share-tooltip{
		position: absolute; background: #fff; border-radius: 4px; font-size: 12px; line-height: 1; top: 120%; right: 20%; white-space: nowrap; padding: 6px 8px; box-shadow: 0px -1px 6px rgba(0,0,0,.2);
		&:before{.pseudo(10px,10px); background: #fff; .rotate(45deg); top: -2px; right: 10px;}
	}
	.share-items{
		display: inline-flex; border: 1px solid var(--borderColor); border-radius: 3px; font-size: 14px;
		@media (max-width: @m){font-size: 12px;}		
	}
	.share-title{
		padding: 0 0 10px; font-size: 12px;
		@media (max-width: @m){padding-bottom: 8px; font-size: 12px;}	
	}
	.ss-item{
		display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; cursor: pointer; position: relative; border-right: 1px solid var(--borderColor);
		&:before{.icon-facebook(); font: 16px/1 var(--fonti); color: var(--blue); z-index: 2; .transition(color);}
		&:after{.pseudo(auto,auto); background: #0866ff; top: -1px; right: -1px; bottom: -1px; left: -1px; opacity: 0; z-index: 1; .transition(opacity);}
		&:hover{
			&:before{color: #fff;}
			&:after{opacity: 1};
		}
	}
	.ss-facebook:after{border-radius: 3px 0 0 3px;}
	.ss-whatsapp{
		&:before{.icon-whatsapp(); font-size: 21px; line-height: 21px;}
		//&:after{background: #25D366;}
		&:hover{
			//background: #25D366;
			&:before{color: #fff;}
		}
	}
	.ss-viber{
		&:before{.icon-viber(); font-size: 20px; line-height: 20px;}
		//&:after{background: #7360f2;}
	}
	.ss-link{
		border: 0; width: auto; padding: 0 15px;
		&:before{margin-right: 8px;.icon-link(); font-size: 19px;}
		.title{position: relative; z-index: 2; .transition(color);}
		&:after{border-radius: 0 3px 3px 0;}
		&:hover{
			.title{color: #fff;}
		}
	}
</style>
